import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'

import { getShowFromFilters } from '@utils/catalog'
import SecondaryHeader from '@reusable-modules/SecondaryHeader/index'
import { filterEntityTypes } from '@constants/entityTypes'
import cities from '@constants/cities'
import { AppContext } from '@providers/AppContext'

const getMenuShows = (props) => {
  const shows = []
  const { query } = props
  // @ts-ignore
  shows.push({ label: props.clt_grp1_all_shows_label, link: query.slug, key: '' })

  const showEntity = props.entities && props.entities.filters && props.entities.filters.length > 0 &&
    props.entities.filters.find(entity => entity.entityType === filterEntityTypes.show)

  if (showEntity?.options) {
    const sortedArray = []
    const findShow = (name) => showEntity.options.find(element => element.value === cities[name])
    const showNames = ['basel', 'miamibeach', 'hongkong', 'paris']
    showNames.map((showName) => {
      let findShowObj = findShow(showName)
      if (findShowObj) {
        // @ts-ignore
        sortedArray.push(findShowObj)
      }
    })
    const menuShows = sortedArray.map((show) => ({
      // @ts-ignore
      label: show.value,
      // @ts-ignore
      link: `${query.slug}?showIds=${show.showIds}`,
      // @ts-ignore
      key: show.showIds
    }))
    // @ts-ignore
    return shows.concat(menuShows)
  }
  return shows
}

class OtmCommonHeader extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    user: PropTypes.object,
    query: PropTypes.object,
    entities: PropTypes.object,
    requestFilters: PropTypes.func,
    setSecondaryMenus: PropTypes.func,
    setCurrentShowTab: PropTypes.func,
    secomComplement: PropTypes.string,
    clt_grp1_favorites: PropTypes.string,
    clt_grp1_title: PropTypes.string,
    clt_grp1_all_shows_label: PropTypes.string,
    router: PropTypes.object,
    siteHostname: PropTypes.object
  }

  state = {
    shows: []
  }

  async requestFiltersData() {
    // @ts-ignore
    const queryData = this.props.query.slug || this.props.router.asPath
    // @ts-ignore
    await this.props.requestFilters(queryData.split('?')[0], { showIds: this.props.query.showIds })
    // @ts-ignore
    if (this.props.query.showIds) {
      // @ts-ignore
      const currentShow = getShowFromFilters(this.props.entities.filters, this.props.query.showIds)
      if (currentShow) {
        // @ts-ignore
        this.props.setCurrentShowTab(currentShow.showIds)
      }
    }
    // @ts-ignore
    const menuShows = getMenuShows(this.props)
    // @ts-ignore
    this.props.setSecondaryMenus(menuShows)
    this.setState({
      shows: menuShows
    })
  }


  componentDidMount() {
    this.requestFiltersData()
  }

  componentDidUpdate(prevProps) {
    // @ts-ignore
    if (this.props?.entities?.secondaryMenus !== prevProps.entities.secondaryMenus) {
      if (this.state.shows.length === 1) {
        this.requestFiltersData()
      }
    }
  }

  getShowName() {
    // @ts-ignore
    const currentShow = getShowFromFilters(this.props.entities.filters, this.props.entities.currentParams.showIds)
    if (currentShow) {
      return currentShow.value
    }
    return ''
  }

  render() {
    const { props, state } = this
    return (
      <SecondaryHeader
        // @ts-ignore
        className={props.className}
        // @ts-ignore
        secom_title1={props.clt_grp1_title}
        secom_title2={this.getShowName()}
        secom_template='horizontal-template'
        // @ts-ignore
        secom_complement={props.secomComplement}
        // @ts-ignore
        secom_favorite_button_label={props.clt_grp1_favorites}
        secom_menu_shows={state.shows}
      />
    )
  }
}

const CommonHeaderWrapper = (props) => {
  const { state: { siteHostName } } = useContext(AppContext)
  return <OtmCommonHeader siteHostname={siteHostName} {...props} />
}

export default withRouter(CommonHeaderWrapper)
